import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { AddressDetails } from '../../../models';
import { SummaryItem } from '../../../../tms-shared';
import { AddressService } from '../../../services';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrl: './address.component.scss',
})
export class AddressComponent implements OnInit {
  @Input() id: string;
  @Input() isModal = false;

  readonly detailsHeader = $localize`Details`;
  readonly addresseeHeader = $localize`Addressees`;

  model$: Observable<AddressDetails>;

  constructor(
    private route: ActivatedRoute,
    public addressService: AddressService,
  ) {}

  ngOnInit() {
    this.getModel();
  }

  summaryTopItems(model: AddressDetails): SummaryItem[] {
    return [
      { label: $localize`Addressee`, value: model.addressee },
      { label: $localize`Name`, value: model.name },
    ];
  }

  getModel() {
    if (!this.id) {
      this.id = this.route.snapshot.paramMap.get('id');
    }
    if (this.id) {
      this.model$ = this.addressService.edit(this.id);
    }
  }
}
